import React, { useCallback, useState, useEffect } from 'react'

import { useDashboard } from '@aytm/app/insights/dashboard/components/hooks'
import { useReports } from '@aytm/app/insights/dashboard/components/sidebar/ReportsPanel/useReports'
import staticStore from '@aytm/app/insights/dashboard/stores/static.store'

import 'primeflex/primeflex.css'
import mcss from './InvokeShareDialogButton.module.scss'
import ShareDialog from './ShareDialog'
import classNames from 'classnames'
import useOuterClickListener from '@aytm/lib/rfd-ui/lib/outer-click-listener'
import { poolDispatch } from '@aytm/app/insights/dashboard/duckness/poolDispatch'
import { makeSaveCurrentViewPortalAction } from '@aytm/app/insights/dashboard/duckness/ducks/PortalDuck/PortalDuck.actionCreators'

export function InvokeShareDialogButton() {
  const { blockUID, requestShareDialog, dismissShareDialog, shareRequested } = useDashboard()
  const { isCurrentModified } = useReports()
  const [isDialogVisible, setIsDialogVisible] = useState(false)

  const handleClickToOpen = useCallback(
    (event: React.MouseEvent) => {
      event.stopPropagation()
      event.preventDefault()

      if (shareRequested) {
        dismissShareDialog()
        setIsDialogVisible(false)
      } else {
        requestShareDialog(blockUID)
        // Delay dialog visibility to prevent race condition with useOuterClickListener
        // The click event needs to complete before the listener is attached
        setTimeout(() => setIsDialogVisible(true), 10)
      }
    },
    [shareRequested, requestShareDialog, blockUID, dismissShareDialog]
  )

  const handleSave = useCallback(
    (event: KeyboardEvent) => {
      if ((event.ctrlKey || event.metaKey) && event.key === 's') {
        event.preventDefault()
        if (isCurrentModified) {
          poolDispatch(makeSaveCurrentViewPortalAction())
        }
      }
    },
    [isCurrentModified]
  )

  const handleHide = useCallback(() => {
    dismissShareDialog()
    setIsDialogVisible(false)
  }, [dismissShareDialog])

  useEffect(() => {
    if (!shareRequested) {
      setIsDialogVisible(false)
    }
  }, [shareRequested])

  useOuterClickListener({ listen: !staticStore.isSharedView, onKeyDown: handleSave })

  if (staticStore.isSharedView) {
    return null
  }

  return (
    <>
      <div
        className={classNames(mcss['invoke-share-dialog-button'], {
          modified: isCurrentModified,
          opened: shareRequested
        })}
        onClick={handleClickToOpen}
      >
        <label className={mcss['button-center']} />
        <i className="icon-aytmfd-config" />
      </div>
      <ShareDialog show={isDialogVisible} onHide={handleHide} />
    </>
  )
}

export default InvokeShareDialogButton
